export const cventTempDocTypes = {
  participants: 'cventParticipants',
}
